export interface ComplaintOption {
  label: string;
  value: string;
}

export const EXTENDED_COMPLAINTS: ComplaintOption[] = [
  {
    label: "Stomachache",
    value: "Stomachache",
  },
  {
    label: "Headache",
    value: "Headache",
  },
  {
    label: "Nausea",
    value: "Nausea",
  },
  {
    label: "Physical Injury",
    value: "Physical Injury",
  },
  {
    label: "Abrasions",
    value: "Abrasions",
  },
  {
    label: "Fever",
    value: "Fever",
  },
  {
    label: "Dizziness",
    value: "Dizziness",
  },
  {
    label: "Eye Irritation",
    value: "Eye Irritation",
  },
  {
    label: "Sore Throat",
    value: "Sore Throat",
  },
  {
    label: "Menstrual Cramps",
    value: "Menstrual Cramps",
  },
  {
    label: "Allergic Reaction",
    value: "Allergic Reaction",
  },
  {
    label: "Nosebleed",
    value: "Nosebleed",
  },
  {
    label: "Toothache",
    value: "Toothache",
  },
  {
    label: "Earache",
    value: "Earache",
  },
  {
    label: "Chest Congestion",
    value: "Chest Congestion",
  },
  {
    label: "General Malaise",
    value: "General Malaise",
  },
  {
    label: "Anxiety",
    value: "Anxiety",
  },
  {
    label: "Insect Bite",
    value: "Insect Bite",
  },
  {
    label: "Heat Exhaustion",
    value: "Heat Exhaustion",
  },
  {
    label: "Acid Reflux",
    value: "Acid Reflux",
  },
  {
    label: "Urinary Tract Infection",
    value: "Urinary Tract Infection",
  },
  {
    label: "Mouth Ulcers",
    value: "Mouth Ulcers",
  },
  {
    label: "Seizure",
    value: "Seizure",
  },
];
